module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-margin-bottom"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("戈壁徒步")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid content-style"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/culture/gbwh_img1.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/culture/gbwh_mp42.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("【玄奘之路】")]), _vm._v(" "), _c('p', [_vm._v("大唐贞观年间，玄奘法师由古丝绸之路经中亚往印度取经、讲学，历时19年，行程5万余里，途经110多个国家。他带回了大昼佛教经典，写就了《大唐西域记》，主持译经1335 卷，远绍如来，近光遗法。")]), _vm._v(" "), _c('p', [_vm._v("1300年前，玄奘法师在这里经历追杀、背弃、迷路、彷徨、生死......最终立下铮铮誓言∶ \"宁可就西而死，岂能归东而生\"， 五天四夜滴水未进几将殒绝，但依然心无所惧一往无前， 最终实现了从坚持到超越的伟大升华。")]), _vm._v(" "), _c('p', [_vm._v("玄奘西行之路1万多公里，行走在这里，沿途会经过草地、丘陵、 河道、沙漠、梭林。在这里，与你同行的不止眼前的同伴，还有远古的生命和早期的圣贤。")]), _vm._v(" "), _c('p', [_vm._v("行走在历史的时空里，去对话这片土地上风沙烈日曾经触及过的生命。")]), _vm._v(" "), _c('h3', [_vm._v("【戈壁精神】")]), _vm._v(" "), _c('p', [_vm._v("玄奘法师迎难而上及坚持不懈的取经精神与同熙精神“做对的事，做难的事，做需要时间沉淀的事”高度契合，每位同熙人都应具备永不言弃的戈壁精神。因此，自2022年起同熙商业正式开展【戈壁远征110公里四天三晚徒步挑战】，将于每年挑选优秀的员工代表参与，一同完成戈壁徒步的极限考验及自我超越。")]), _vm._v(" "), _c('h3', [_vm._v("【熙一 · 2022】")]), _vm._v(" "), _c('p', [_vm._v("出行时间：2022年9月6日—11日")]), _vm._v(" "), _c('p', [_vm._v("出行人数：10人")]), _vm._v(" "), _c('p', [_vm._v("徒步主题：风里劲闯，不息自强")]), _vm._v(" "), _c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/culture/gbwh_mp4bg.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/culture/gbwh_mp4.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")]), _vm._v(" "), _c('p', [_vm._v("如果一个团队，具备了清晰的目标、吃苦的准备、坚忍的意志、互助的品格、奋进的精神，定能披荆斩棘、勇立潮头。未来，所有同熙人将带着这股戈壁精神勇往直前，克服万难，抵达胜利的终点！")]), _vm._v(" "), _c('a', {
    staticClass: "text_a",
    attrs: {
      "href": "https://mp.weixin.qq.com/s/Ws7en9GNBKRI0eMBe05BEg",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")]), _vm._v(" "), _c('h3', [_vm._v("【熙二 · 2023】")]), _vm._v(" "), _c('p', [_vm._v("出行时间：2023年9月9日—14日")]), _vm._v(" "), _c('p', [_vm._v("出行人数：10人")]), _vm._v(" "), _c('p', [_vm._v("徒步主题：无畏无惧，奋勇向前")]), _vm._v(" "), _c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/culture/gbwh_mp4bg2.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/culture/gbwh_mp4_2.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")]), _vm._v(" "), _c('p', [_vm._v("“逆境和挑战只要能激发起生命的力度，我们的成就是可以超乎自己所想象的”。戈壁是一条由勇气、信念、坚持浇铸而成的文化传承之路，也是锻炼同熙人坚强意志之路。熙军用乐观向上的心态，永不言弃的毅力，团结协助的品质去面对和战胜一切困难。无畏无惧，奋勇向前！")]), _vm._v(" "), _c('a', {
    staticClass: "text_a",
    attrs: {
      "href": "https://mp.weixin.qq.com/s/LV5MB3MYNpOYrOjvs4Y7sg",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49ea1fe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/culture.vue
// module id = 106
// module chunks = 3